export const GET_SELLERS = 'src/pages/sellers/GET_SELLERS';
export const GET_SELLERS_SUCCESS =
  'src/pages/sellers/GET_SELLERS_SUCCESS';
export const GET_SELLERS_FAILED = 'src/pages/sellers/GET_SELLERS_FAILED';

export const UPDATE_SELLER_STATUS = 'src/pages/sellers/UPDATE_SELLER_STATUS';
export const UPDATE_SELLER_STATUS_SUCCESS = 'src/pages/sellers/UPDATE_SELLER_STATUS_SUCCESS';
export const UPDATE_SELLER_STATUS_FAILED = 'src/pages/sellers/UPDATE_SELLER_STATUS_FAILED';

export const CREATE_SELLER = 'src/pages/sellers/CREATE_SELLER';
export const CREATE_SELLER_SUCCESS = 'src/pages/sellers/CREATE_SELLER_SUCCESS';
export const CREATE_SELLER_FAILED = 'src/pages/sellers/CREATE_SELLER_FAILED';
